const elementTypeIds = {
    TEXT: '3dcb87aa-8bb5-4482-bdfb-4e70ec6e9dda',
    VIDEO: 'a7b240df-6353-46ca-81a5-4057e9fb9f19',
    RICH_TEXT: '217f10ba-a9dd-488d-9841-7778556e7488',
    IMAGE: '995bbd9b-5168-47f3-855d-13b658b47760',
    TEXT_AREA: '3dcb87aa-8bb5-4482-bdfb-4e70ec6e9dda',
}

export default elementTypeIds


// WEBPACK FOOTER //
// ./src/constants/element-types.js